import React from 'react'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import cloudinary from 'utils/cloudinary'
import RichTextContent from 'components/RichTextContent/RichTextContent'
import injectTranslate from 'i18n/hoc/injectTranslate'
import PropTypes from 'prop-types'

const SeeAnswersBlock = ({ translate }) => (
  <Container mdPadding="top-lg">
    <Title headingLevel="2" align="center">
      {translate('propage.block7.title')}
    </Title>
    <Row padding="md" mdPadding="vertical-lg" hasVerticalAlign columnReverse>
      <Col sm="12" md="4" offset="1">
        <UniverseLink
          id="propage-block7-link"
          href="https://lecoindespros.quotatis.fr/help-center/"
          isBold
          icon="arrow-right-blue"
          iconPosition="right"
          iconSize="sm"
        >
          {translate('propage.block7.link')}
        </UniverseLink>
        <RichTextContent
          margin="top-md"
          content={translate('propage.block7.text')}
        />
      </Col>
      <Col sm="12" md="5" offset="1">
        <Image
          src={cloudinary('/vitrine/image/team.png')}
          size="full"
          alt={translate('alt.pro.team')}
        />
      </Col>
    </Row>
  </Container>
)

SeeAnswersBlock.propTypes = {
  translate: PropTypes.func,
}

export default injectTranslate(SeeAnswersBlock)
